import {gql} from "@irati/utils/gql"

import dealLocation from "./dealLocation"
import userSavings from "./dealUserSavings"
import boostedSavings from "./dealBoostedSavings"
import fullDealProductConfig from "./fullDealProductConfig"

const fragment = gql`
  fragment fullDeal on Deal {
    offers {
      uuid
      kind
      url
    }
    algoliaQueryId
    bannerImage
    brandName
    brandId
    brand {
      bannerUrl
      description
      logoUrl
      slug
    }
    cardImage
    contactInfo
    date
    dateTurnedOn
    dateUnix
    deliveryHighlight
    deliveryInfo
    description
    emailRequired
    externalIdentifier
    externalLinks {
      android
      ios
      web
    }
    externalLoginUrl
    frequentlyAskedQuestions {
      question
      answer
    }
    header
    howItWorks
    importantInfo
    internalIdentifier
    isValidFor24Hours
    isTTDeal
    keywords
    locale
    location {
      ...fullDealLocation
    }
    packageEligibility {
      whitelist {
        packageIds
        criteria {
          region
        }
      }
      blacklist {
        packageIds
        criteria {
          region
        }
      }
    }
    popularity
    popularityAU
    popularityUK
    productConfig {
      ...fullDealProductConfig
    }
    redemptionInstructions
    savings {
      ...userSavings
      ...boostedSavings
    }
    status
    tagIds
    teamIds
    template
    tenant
    termsAndConditions
    thumbnailImage
    type
    typeHighlight
    urlSlug
    uuid
    websiteUrl
    paymentOptions {
      zip {
        enabled
        rate
      }
    }
    provider
    earnPoints
    regionIds
    reviewState
    brandTagIds
    increasedPointsBackPercentageDelta
    cashbackETADays
    dedupRuntimeId
    duplicateOfId
  }
  ${dealLocation}
  ${userSavings}
  ${boostedSavings}
  ${fullDealProductConfig}
`

export const toString = fragment.loc.source.body

export default fragment
